import React, { Component } from 'react'
import safeImage from '../safeWithoutButtonsOrHandle.png'
import openSafe from '../safeOpen.png'
import safeButton1 from '../safeButton1.png'
import safeButton2 from '../safeButton2.png'
import safeButton3 from '../safeButton3.png'
import safeButton4 from '../safeButton4.png'
import safeButton5 from '../safeButton5.png'
import safeButton6 from '../safeButton6.png'
import safeButton7 from '../safeButton7.png'
import safeButton8 from '../safeButton8.png'
import safeButton9 from '../safeButton9.png'
import safeButton0 from '../safeButton0.png'
import safeButtonC from '../safeButtonC.png'
import safeButtonHash from '../safeButton#.png'
import safeHandle from '../safeHandle.png'
import trophy from '../trophy.png'
import styles from '../Safe.module.css'

class Safe extends Component {
    constructor(){
        super();
        this.state = {
            digitsOnDisplay: "",
            trophyHasBeenCollected: false
        };
    }
    enterDigit(digit){
        if(this.state.digitsOnDisplay.length>4){return}
        this.setState((prevState) => ({
            digitsOnDisplay: prevState.digitsOnDisplay+digit
        }));
    }
    clearDisplay = () => {
        this.setState({
            digitsOnDisplay: ""
        });
    }
    handleHandleClick = () => {
        if(this.state.digitsOnDisplay==="43517"){
            this.openSafe();
        }
    }
    openSafe(){
        document.getElementById('safeArea').classList.add('theSafeIsOpen');
    }
    enter1 = () => {
        if(this.state.digitsOnDisplay.length>4){return}
        this.setState((prevState) => ({
            digitsOnDisplay: prevState.digitsOnDisplay+"1"
        }));
    }
    handleTrophyClick = () => {
        document.body.classList.add("championMode");
        this.setState({
            trophyHasBeenCollected: true
        });
    }
    render() {
        const trophyImage = this.state.trophyHasBeenCollected ?
            " " : <img alt="A trophy" src={trophy} id={styles.trophy} onClick={this.handleTrophyClick} />
        return (
            <div id="safeArea">
                <div id={styles.openSafeArea} className="openSafeArea">
                    <img alt="An open safe" src={openSafe} id={styles.openSafe} />
                    <div id={styles.congratulationsMessage}>
                        <h1>Congratulations!</h1>
                        <p>You have cracked my safe and discovered all the secrets of my website. Here is your reward:</p>
                    </div>
                    {trophyImage}
                </div>
                <img alt="A safe" src={safeImage} id={styles.safe} />
                <div id={styles.numberButtonsWrapper}>
                    <img onClick={this.enter1} alt="Keypad button 1" src={safeButton1}/>
                    <img onClick={() => this.enterDigit("2")} alt="Keypad button 2" src={safeButton2}/>
                    <img onClick={() => this.enterDigit("3")} alt="Keypad button 3" src={safeButton3}/>
                    <img onClick={() => this.enterDigit("4")} alt="Keypad button 4" src={safeButton4}/>
                    <img onClick={() => this.enterDigit("5")} alt="Keypad button 5" src={safeButton5}/>
                    <img onClick={() => this.enterDigit("6")} alt="Keypad button 6" src={safeButton6}/>
                    <img onClick={() => this.enterDigit("7")} alt="Keypad button 7" src={safeButton7}/>
                    <img onClick={() => this.enterDigit("8")} alt="Keypad button 8" src={safeButton8}/>
                    <img onClick={() => this.enterDigit("9")} alt="Keypad button 9" src={safeButton9}/>
                    <img onClick={() => this.enterDigit("#")} alt="Keypad button Hash" src={safeButtonHash}/>
                    <img onClick={() => this.enterDigit("0")} alt="Keypad button 0" src={safeButton0}/>
                    <img onClick={this.clearDisplay} alt="Keypad button C" src={safeButtonC}/>
                </div>
                <span id={styles.safeLCDDisplay}>{this.state.digitsOnDisplay}</span>
                <img onClick={this.handleHandleClick} alt="Safe handle" src={safeHandle} id={styles.safeHandle} />   
            </div>
        )
    }
}

export default Safe